// for search type toggle buttons:
import React from "react";
import MobileIconSvg from "./images/MobileIconSvg";
import MobilePhotoSvg from "./images/MobilePhotoSvg";

export const searchTypeButtons = [
    {
        value: "Icons",
        icon: <MobileIconSvg />
    },
    {
        value: "Photos",
        icon: <MobilePhotoSvg />
    }
];

// placeholder text for search input:
export const heroSearchPlaceholderIcons = {
    desktop: "Search over 3 million icons",
    tablet: "Search icons",
    mobile: "Search"
};

export const heroSearchPlaceholderPhotos = {
    desktop: "Search art-quality photos",
    tablet: "Search photos",
    mobile: "Search"
};
